import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/home/home').then((m) => m.Home),
  },
  {
    path: 'articulo/:slug',
    loadComponent: () =>
      import('./features/article/article-detail/article-detail').then((m) => m.ArticleDetail),
  },
  {
    path: 'etiqueta/:tag',
    loadComponent: () => import('./features/tag/tag-list/tag-list').then((m) => m.TagList),
  },
  {
    path: 'buscar',
    loadComponent: () => import('./features/search/search').then((m) => m.Search),
  },
  {
    path: 'archivo',
    loadComponent: () => import('./features/archive/archive').then((m) => m.Archive),
  },
  {
    path: 'sobre-mi',
    loadComponent: () => import('./features/about/about').then((m) => m.About),
  },
  {
    path: '**',
    loadComponent: () => import('./features/not-found/not-found').then((m) => m.NotFound),
  },
];
